import { createSelector } from "reselect";
import { type RootState } from "../../Application/globaltypes/redux";
import { RolePermissions } from "../../../enums";

const getPermissions = (state: RootState) => state.userProfile.permissions;

export const hasFlowViewPermissionSelector = createSelector([getPermissions], (permissions) =>
  permissions.includes(RolePermissions.FlowsView),
);
